// eslint-disable-next-line import/prefer-default-export
export const get = (obj, pathIn, defaultValue) => {
  const path = pathIn.replace(/\[/g, '.').replace(/\]/g, '');
  const i = path.indexOf('.');
  const key = i > 0 ? path.substring(0, i) : path;
  const newObj = obj[key];
  if (newObj === undefined) {
    return defaultValue;
  }
  if (key === path) return newObj;
  return get(newObj, path.substring(i + 1), defaultValue);
};

export const debounce = function (func, wait, immediate) {
  let timeout;

  return function executedFunction() {
    const context = this;
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;

    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
};
